import { Box, Button } from '@streem/ui-react';
import { FC } from 'react';

interface PreviewButtonProps {
    onClick: () => void;
}

export const PreviewButton: FC<React.PropsWithChildren<PreviewButtonProps>> = ({ onClick }) => {
    return (
        <Box mt={5}>
            <Button
                style={{ background: 'transparent' }}
                onClick={onClick}
                variant="secondary"
                data-testid="preview-video-button"
            >
                Preview
                <span style={{ transform: 'translateY(1px)', marginLeft: '5px' }}>&#9658;</span>
            </Button>
        </Box>
    );
};
